import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Typography } from '@mui/material';
import MUIDrawer from '@mui/material/Drawer';

import Tag from '../Tag';

import { ViewDrawerProps } from './props';

export const ViewDrawer: React.FC<ViewDrawerProps> = (props) => {
  const {
    children,
    open = false,
    onClose,
    drawerWidth = 500,
    title,
    subTitle,
    titleProps,
    subTitleProps,
    tagProps,
  } = props;
  // ================== RENDER FUNCTIONS
  const drawer = (
    <Box sx={{ padding: '30px' }}>
      <Box className={'flex w-full justify-end mb-3.5'}>
        <IconButton onClick={onClose}>
          <CloseIcon fontSize={'small'} />
        </IconButton>
      </Box>
      {title ? (
        <Box className={'flex w-full justify-between'}>
          <Typography
            variant={'h6'}
            className={'font-semibold'}
            {...titleProps}
          >
            {title}
          </Typography>
          {tagProps?.category ? <Tag {...tagProps} /> : null}
        </Box>
      ) : null}

      {subTitle ? (
        <Typography
          variant={'body2'}
          className={'font-semibold'}
          color={'secondary'}
          {...subTitleProps}
        >
          {subTitle}
        </Typography>
      ) : null}

      {children}
    </Box>
  );

  // ================== VIEWS
  return (
    <MUIDrawer
      variant="temporary"
      open={open}
      onClose={onClose}
      ModalProps={{
        keepMounted: true,
      }}
      anchor={'right'}
      sx={{
        display: 'block',
        '& .MuiDrawer-paper': {
          boxSizing: 'border-box',
          width: { xs: '100%', md: drawerWidth },
        },
      }}
    >
      {drawer}
    </MUIDrawer>
  );
};

export default ViewDrawer;
